import { CREDENTIAL_ERROR_CODE } from 'config/credentialErrorCodes';

// The published refusal codes from POST /people/bulk and PATCH /people/access. The prose in
// errors[] will change; a code is only published when it names the exact fix, so branch on these.
export const PEOPLE_ERROR_CODE = {
	MOBILE_CREDENTIAL_REQUIRES_EMAIL: 'MOBILE_CREDENTIAL_REQUIRES_EMAIL',
	MOBILE_CREDENTIAL_NOT_FOR_ACCESS_ONLY: 'MOBILE_CREDENTIAL_NOT_FOR_ACCESS_ONLY',
	MOBILE_CREDENTIAL_NOT_TRANSFERABLE: 'MOBILE_CREDENTIAL_NOT_TRANSFERABLE',
	// Relayed from the credential write; its message lives in credentialErrorCodes.
	PASSCODE_IN_USE: CREDENTIAL_ERROR_CODE.PASSCODE_IN_USE,
	// Floating room cards: a card is added to, or taken off, a room only through its own flow (DA1-05).
	ROOM_ISSUE_VIA_ASSIGN: 'ROOM_ISSUE_VIA_ASSIGN',
	ROOM_CARD_RETURN_REQUIRED: 'ROOM_CARD_RETURN_REQUIRED'
};

// The fix each code names, in our words. An unknown code adds nothing — the prose stands alone.
export const PEOPLE_ERROR_CODE_FIX = {
	[PEOPLE_ERROR_CODE.MOBILE_CREDENTIAL_REQUIRES_EMAIL]: 'Add an email address to issue the mobile credential.',
	[PEOPLE_ERROR_CODE.MOBILE_CREDENTIAL_NOT_FOR_ACCESS_ONLY]:
		'This person type never signs in, so it cannot hold a mobile credential.',
	[PEOPLE_ERROR_CODE.MOBILE_CREDENTIAL_NOT_TRANSFERABLE]:
		'A mobile credential cannot be moved — issue one for this person instead.',
	[PEOPLE_ERROR_CODE.ROOM_ISSUE_VIA_ASSIGN]:
		"Assign the card to the room from the card's own screen to confirm the stay.",
	[PEOPLE_ERROR_CODE.ROOM_CARD_RETURN_REQUIRED]: 'Return the card to Base cards instead of removing it from the room.'
};
